export function eventTypeToString(value: number): string {
  if (value === 0) {
    return 'Получение данных';
  }

  return 'Неизвестное';
}
